 (function() {
  'use strict';

  Vue.config.devtools = true;

  Vue.config.errorHandler = function(err, vm, info) {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    console.log('errorHandler');
    console.log(1, err);
    console.log(2, vm);
    console.log(3, info);
    // TODO: Perform any custom logic or log to server
  };

  var $ = avm.require('jquery'),
    supportedOSes = ['mac', 'pc', 'android'],
    urlOS = window.location.hash ? supportedOSes[supportedOSes.indexOf(window.location.hash.substring(1))] : null,
    detectedOS = urlOS ? urlOS : avastGlobals.detect.os.name.toLowerCase(),
    ctaBoxes = [],
    $ctaBox = $('.premium-security-ruaw-adb-cta'),
    $linksBox = $('.premium-security-ruaw-adb-links');

  if (detectedOS === 'pc') {
    detectedOS = 'windows'
  }

  // Return if no Action boxes present on page
  // @todo : this can be defined in avast.js config where modules boot
  if ($ctaBox.length === 0 || $linksBox.length === 0) {
    return false
  }

  $ctaBox.each(function() {
    var boxId = $(this).attr('id')
    if (boxId) {
      ctaBoxes.push(new Vue({
        el: '#'+boxId,
        delimiters: ['<%', '%>'],
        data: {
          platform: detectedOS,
        },
      }))
    }
  })

  $linksBox.each(function() {
    var linksId = $(this).attr('id')
    if (linksId) {
      new Vue({
        el: '#'+linksId,
        delimiters: ['<%', '%>'],
        data: {
          platform: detectedOS,
        },
        methods: {
          refreshDetectedOS: function (event) {
            event.preventDefault()

            var urlOS = window.location.hash ? supportedOSes[supportedOSes.indexOf(event.target.hash.substring(1))] : null,
              detectedOS = urlOS ? urlOS : avastGlobals.detect.os.name.toLowerCase();

            history.pushState(null, null, event.target.hash)

            if (detectedOS === 'pc') {
              detectedOS = 'windows'
            }

            $(ctaBoxes).each(function(thisBox) {
              ctaBoxes[thisBox].platform = detectedOS
            })

            this.platform = detectedOS

            event.target.blur()
          }
        },
      })
    }
  })
})()
